export const ColumnCommandsStyle = {
  justifyContent: 'flex-end',
  alignContent: 'flex-end',
  width: '250px',
  marginRight: '10px'
};
